import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Converts a CSS color value (including oklch) to rgba format
 * Uses the browser's getComputedStyle to handle the conversion
 */
export function getColorAsRgba(cssColor: string): string {
  if (!cssColor) return "rgba(0, 0, 0, 1)"

  // If it's already in rgb/rgba format, return as is
  if (cssColor.startsWith("rgb")) {
    return cssColor
  }

  // Create a temporary element to get computed color
  const tempEl = document.createElement("div")
  tempEl.style.color = cssColor
  tempEl.style.position = "absolute"
  tempEl.style.visibility = "hidden"
  tempEl.style.pointerEvents = "none"
  document.body.appendChild(tempEl)

  const computed = getComputedStyle(tempEl)
  const rgba = computed.color || "rgba(0, 0, 0, 1)"

  document.body.removeChild(tempEl)

  return rgba
}
